import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const teamMembers = [
    {
      name: 'Georges YAKAN',
      role: 'Dirigeant',
      image: `${process.env.PUBLIC_URL}/baboimmo_gerant.jpg`,
      description: 'Expert en gestion immobilière et promotion depuis plus de 20 ans. Passionné par l\'immobilier et engagé à fournir des solutions innovantes.'
    },
    // {
    //   name: 'Jean-Marie',
    //   role: 'Coordinateur de Travaux',
    //   image: `${process.env.PUBLIC_URL}/baboimmo_coordinateur.jpg`,
    //   description: 'Spécialiste gestion immobilière, coordination et suivi des travaux sur le terrain depuis plus de 10 ans.'
    // }
  ];

  return (
    <div className="animate-fade-in">
      <Helmet>
        <title>JVG7 - Gestion de Biens et Promotion Immobilière</title>
        <meta name="description" content="JVG7, société civile immobilière à Villiers-le-Bel. Location de terrains, gestion de biens et promotion immobilière. Contactez-nous pour vos projets." />
        <meta name="keywords" content="JVG7, immobilier, gestion de biens, location, Villiers-le-Bel, Georges Yakan, promotion immobilière" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative h-[600px] bg-gradient-to-r from-primary-600 to-primary-800 text-white">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in">
            JVG7
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-2xl">
            Votre partenaire de confiance pour tous vos projets de rénovation et promotion immobilière
            <br />
            La propriété, la gestion et l'exploitation immobilière par excellence.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/projects"
              className="bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Découvrir nos projets
            </Link>
            <Link
              to="/contact"
              className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-colors"
            >
              Nous contacter
            </Link>
          </div>
        </div>
      </section>

      {/* À propos Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Qui sommes-nous ?
            </h2>
            <div className="w-20 h-1 bg-primary-600 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/baboimmo_home_photo.png`}
                alt="Immeuble moderne"
                className="rounded-lg shadow-xl"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Société Civile Immobilière depuis 2004
              </h3>
              <p className="text-gray-650 mb-4">
                JVG7 est une société civile spécialisée dans la rénovation, la location de terrains et d'autres biens immobiliers.
                Fondée le 27 septembre 2004, nous mettons notre expertise au service de la gestion et de l'exploitation de biens immobiliers.
                <br />
                <br />
                Depuis notre création, nous avons accompagné de nombreux clients dans la réalisation
                de leurs projets immobiliers. Le passion et le savoir de notre société sont notre plus grand atout.
              </p>
              <div className="grid grid-cols-2 gap-6 mt-8">
                <div>
                  <h4 className="text-3xl font-bold text-primary-600">50+</h4>
                  <p className="text-gray-600">Projets réalisés</p>
                </div>
                <div>
                  <h4 className="text-3xl font-bold text-primary-600">20+</h4>
                  <p className="text-gray-600">Années d'expérience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Équipe Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              L'homme derrière JVG7 
            </h2>
            <div className="w-20 h-1 bg-primary-600 mx-auto mb-6"></div>
          </div>

          <div className="flex justify-center gap-8 flex-wrap">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow w-full md:w-80"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-primary-600 font-semibold mb-3">{member.role}</p>
                  <p className="text-gray-600 text-sm">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* RGPD & CTA Section */}
      <section className="py-16 bg-primary-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Un projet immobilier ?
          </h2>
          <p className="text-xl mb-8">
            Contactez-nous pour échanger sur vos besoins dans vos projets immobiliers futurs.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors mb-12"
          >
            Nous contacter
          </Link>

          <div className="border-t border-primary-500 pt-8 mt-8 text-sm opacity-80">
            <h3 className="font-bold mb-2">Protection des Données (RGPD)</h3>
            <p>
              Les informations recueillies sur ce site sont enregistrées dans un fichier informatisé par JVG7 pour la gestion des demandes de contact.
              Elles sont conservées pendant la durée nécessaire au traitement de la demande et sont destinées uniquement à la direction de JVG7.
              Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en nous contactant.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
